import { fetchWrapper } from '../../utils';

export class generals {
  static baseUrl = process.env.REACT_APP_BASE_API + 'professor';

  static async getLapses(params) {
    const url = `${this.baseUrl}/lapses`;
    return await fetchWrapper.post(url, params);
  }

  static async getSubjects(params) {
    const url = `${this.baseUrl}/subjects`;
    return await fetchWrapper.post(url, params);
  }
}
